import { makeActionCreator } from '../actions/actionCreators';

export enum TermsOfServiceActionTypes {
  ACCEPT_TERMS_OF_SERVICE = 'termsOfService/accept',
}

export const acceptTermsOfService = makeActionCreator(TermsOfServiceActionTypes.ACCEPT_TERMS_OF_SERVICE)();

export type TermsOfServiceActions = ReturnType<typeof acceptTermsOfService>;
